import {createAction, props} from '@ngrx/store';
import {Share} from '../domain';
import {Page} from '../../components/common-interfaces';
import {MultishareHistoryFilter} from './multishare-history-table/multishare-history-table.component';

export const loadMultishareHistorys = createAction(
  '[MultishareHistory] Load MultishareHistorys',
  props<{ filter: MultishareHistoryFilter }>()
);

export const loadMultishareHistorysSuccess = createAction(
  '[MultishareHistory] Load MultishareHistorys Success',
  props<{ historiesPage: Page<Share> }>()
);
